import React, { useState, useEffect } from "react";
import style from "./VideoComponent.module.css";

const VideoComponent = ({ video, setOpenVideo }) => {
  const [opacity, setOpacity] = useState(0);
  const [autoPlay, setAutoPlay] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setOpacity(1);
      setAutoPlay(true);
    }, 100);
  }, []);

  const handleClose = () => {
    setOpacity(0);
    setTimeout(() => {
        setOpenVideo(false);
    }, 500);
  };
  return (
    <div className={style.videoComponent}  style={{opacity: opacity}}>
      <div>
        <button onPointerDown={handleClose}>x</button>

        <video
          src={video.url}
          controls
          controlsList="nodownload"
          autoPlay
          className={style.video}
          onEnded={() => {
            video.setSeen(true);
            handleClose();
          }}
        />
      </div>
    </div>
  );
};

export default VideoComponent;
